// @flow

import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { SnackbarContent, Snackbar, IconButton } from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
  snackbarContent: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  errorIcon: {
    fontSize: 20,
    marginRight: theme.spacing(2),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}))

type Props = {
  open: boolean,
  children: React.Node,
  onClose: (null) => mixed,
}

function ErrorSnackbar({ open, children, onClose }: Props) {
  const classes = useStyles()

  const handleClose = React.useCallback(
    (e, reason) => {
      if (reason !== 'clickaway') {
        onClose(null)
      }
    },
    [onClose]
  )

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      open={open}
      onClose={handleClose}
    >
      <SnackbarContent
        className={classes.snackbarContent}
        message={
          <span className={classes.message}>
            <ErrorIcon className={classes.errorIcon} />
            {children}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
            data-cypress="error-snackbar-close"
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  )
}

export default React.memo<Props>(ErrorSnackbar)
